/**
 * Where a rejected upload happened. Stored as-is in file_upload_rejections.context,
 * so rename a value only together with a data migration.
 */
export const FILE_UPLOAD_CONTEXT = Object.freeze({
    FILE_SUBMISSION_STUDENT: 'file_submission_student',
    ATTACHMENT_SUBMISSION_STUDENT: 'attachment_submission_student',
    ACKNOWLEDGE_INFORMATION_STUDENT: 'acknowledge_information_student',
    ACTIVITY_ATTACHMENT_INSTRUCTOR: 'activity_attachment_instructor',
    ACTIVITY_PAGE_ATTACHMENT_INSTRUCTOR: 'activity_page_attachment_instructor',
    ANNOUNCEMENT_ATTACHMENT_INSTRUCTOR: 'announcement_attachment_instructor',
    GRADER_FEEDBACK_ATTACHMENT: 'grader_feedback_attachment',
    GRADEBOOK_FEEDBACK_ATTACHMENT: 'gradebook_feedback_attachment',
    NOTE_ATTACHMENT: 'note_attachment',
    PAGE_ATTACHMENT: 'page_attachment',
    COURSE_CODE_ATTACHMENT: 'course_code_attachment',
    SUPPORT_TICKET_ATTACHMENT: 'support_ticket_attachment',
    USER_PHOTO: 'user_photo',
    INSTITUTION_LOGO: 'institution_logo',
    VIDEO_UPLOAD: 'video_upload',
    SLIDE_DECK_UPLOAD: 'slide_deck_upload',
    ELEARNING_PACKAGE_UPLOAD: 'elearning_package_upload',
    FLASHCARD_SOURCE_UPLOAD: 'flashcard_source_upload',
    FLASHCARD_IMAGE_UPLOAD: 'flashcard_image_upload',
    EXTERNAL_CONTENT_COURSE_GENERATION: 'external_content_course_generation',
    EXTERNAL_CONTENT_SECTION_IMPROVE: 'external_content_section_improve',
    EXTERNAL_CONTENT_ACTIVITY_ENHANCE: 'external_content_activity_enhance',
    EXTERNAL_CONTENT_QUIZ_SETUP: 'external_content_quiz_setup',
    ENROLLMENT_CSV_IMPORT: 'enrollment_csv_import',
    QUIZ_IMPORT: 'quiz_import',
    RUBRIC_CRITERIA_IMPORT: 'rubric_criteria_import',
    EDITOR_INLINE_IMAGE: 'editor_inline_image',
    UNSPECIFIED: 'unspecified',
});

/**
 * Copy of App\Enums\FileUploadRejectionReason, which owns these values.
 * FileUploadRejectionClientContractTest fails if the two differ.
 */
export const FILE_UPLOAD_REJECTION_REASON = Object.freeze({
    FILE_TOO_LARGE: 'file_too_large',
    UNSUPPORTED_FILE_TYPE: 'unsupported_file_type',
    TOO_MANY_FILES: 'too_many_files',
    TOTAL_SIZE_EXCEEDED: 'total_size_exceeded',
    INVALID_FILE: 'invalid_file',
    SERVER_ERROR: 'server_error',
});

/** Copy of FileUploadRejectionRequest::MAX_REJECTIONS_PER_REQUEST, checked by FileUploadRejectionClientContractTest. */
export const MAX_REJECTIONS_PER_REQUEST = 20;
